<script lang="ts">
  import { copy } from "../lib/stores/copy";
  import Charm from "../assets/charm_v2.webp";
  import CallingCard from "../assets/calling_card_v2.webp";
  import Emblem from "../assets/emblem_v2.webp";
  import SkinPopup from "../assets/bo7-skin.webp";
  import { languageStore } from "../lib/stores/language";
  import CloseButton from "./CloseButton.svelte";
  import { isPrimaryCampaign } from "../lib/constants/countries";

  export let showPopup: boolean;
</script>

<div class={[
  "std-popup__panel absolute left-[50%] z-[50]",
  "min-w-[230px] pt-[12px]",
  "border-solid border-white border-4 rounded-[6px]",
  "bg-cover bg-no-repeat bg-center",
  "opacity-0 invisible transition duration-200",
  "laptop:w-[280px] desktop:w-[320px] desktopLg:w-[400px]",
  isPrimaryCampaign ? "bottom-[100%]" : "std-popup__panel--down"
].join(" ")}>
  <CloseButton onClick={() => showPopup = false} classNames="text-white border-white bg-transparent" />
  <div class="overflow-hidden pb-[22px]">
    <div class="flex gap-2 mt-[14px] desktop:mt-[18px] desktopLg:mt-[24px] mb-2">
      <div class="mx-4">
        <div class={[
          "text-left text-shadow font-MrEavesXLSanNarOTUltra",
          "text-[8px] text-white font-black uppercase",
          "laptop:text-[10px] desktop:text-[12px] desktopLg:text-[14px]"
        ].join(" ")}>
          {$copy.prizeNames.callingCard}
        </div>
        <div class="flex items-center justify-center">
          <img src={CallingCard} alt="">
        </div>
      </div>
    </div>
    <div class="flex gap-2 justify-start flex-row">
      <div class="w-[50%] relative">
        <div class={[
          "absolute z-20 leading-[1]",
          "text-shadow font-MrEavesXLSanNarOTUltra",
          "text-[8px] text-white font-black uppercase",
          "laptop:text-[10px] desktop:text-[12px] desktopLg:text-[14px]",
          $languageStore === 'en' ? 'top-[20%] left-[54%]' : 'top-[16%] left-[53%]'
        ].join(" ")}>
          {@html $copy.prizeNames.operatorSkinSplit}
        </div>
        <div class="flex items-center justify-center w-[150%] absolute top-[-10px] laptop:top-[-12px] desktop:top-[-14px] desktopLg:top-[-16px] left-[-45%]">
           <img src={SkinPopup} alt="" class="mask-fade-35"
           >
        </div>
      </div>
      <div class="flex gap-2 flex-col w-[50%] pr-2">
        {#if isPrimaryCampaign}
          <div class="w-[66%]">
            <div class={[
              "text-shadow font-MrEavesXLSanNarOTUltra",
              "text-[8px] text-white font-black uppercase",
              "laptop:text-[10px] desktop:text-[12px] desktopLg:text-[14px]"
            ].join(" ")}>
              {$copy.prizeNames.emblem}
            </div>
            <div class="flex items-center justify-center">
              <img src={Emblem} alt="">
            </div>
          </div>
          <div class="w-[50%] self-end mt-[-10%] mr-[10%] relative">
            <div class="absolute z-20 right-[66%] top-[31%] translate-y-[-50%] text-right">
              <div class={[
                "text-shadow font-MrEavesXLSanNarOTUltra",
                "text-[8px] text-white font-black uppercase",
                "laptop:text-[10px] desktop:text-[12px] desktopLg:text-[14px]",
                "leading-[1]"
              ].join(" ")}>
                {$copy.prizeNames.charm}
              </div>
            </div>
            <div class="flex items-center justify-center">
              <img src={Charm} alt="">
            </div>
          </div>
        {:else}
          <div class="w-[50%] self-end mt-[-30%] mr-[10%] relative">
            <div class="absolute z-20 right-[66%] top-[31%] translate-y-[-50%] text-right">
              <div class={[
                "text-shadow font-MrEavesXLSanNarOTUltra",
                "text-[8px] text-white font-black uppercase",
                "laptop:text-[10px] desktop:text-[12px] desktopLg:text-[14px]",
                "leading-[1]"
              ].join(" ")}>
                {$copy.prizeNames.charm}
              </div>
            </div>
            <div class="flex items-center justify-center">
              <img src={Charm} alt="">
            </div>
          </div>
          <div class="w-[66%] self-center">
            <div class={[
              "text-shadow font-MrEavesXLSanNarOTUltra",
              "text-[8px] text-white font-black uppercase",
              "laptop:text-[10px] desktop:text-[12px] desktopLg:text-[14px]"
            ].join(" ")}>
              {$copy.prizeNames.emblem}
            </div>
            <div class="flex items-center justify-center">
              <img src={Emblem} alt="">
            </div>
          </div>
        {/if}
      </div>
    </div>
    {#if isPrimaryCampaign}
      <div class="flex justify-center mt-[22px]">
        <p class={[
          "z-[1] h-min font-MrEavesXLSanNarOTUltra text-white font-black leading-[0.9] uppercase text-shadow",
          "text-[14px] laptop:text-[15px] desktop:text-[18px] desktopLg:text-[21px]"
        ].join(" ")}>
          <span class="font-LCScript text-primary capitalize leading-[0.75]">{@html $copy.prizeNames.plus}</span>
          {@html $copy.prizeNames.youCanWinSplit}
        </p>
      </div>
    {/if}
  </div>
  <div class={[
    "std-popup__triangle",
    !isPrimaryCampaign && "std-popup__triangle--down"
  ].filter(Boolean).join(" ")}></div>
</div>
